import { render, staticRenderFns } from "./DashboardTableComponent.vue?vue&type=template&id=2f078ca2&scoped=true&"
import script from "./DashboardTableComponent.vue?vue&type=script&lang=ts&"
export * from "./DashboardTableComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTableComponent.vue?vue&type=style&index=0&id=2f078ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f078ca2",
  null
  
)

export default component.exports